// Registro público de cuentas deshabilitado: el acceso se otorga previa evaluación
// vía contacto. SignUpPage y UsersRegistration se conservan para una posible
// reactivación, que además exige reabrir POST /app-user/register-user en el backend
// (hoy restringido a administradores).
export const PUBLIC_SIGNUP_ENABLED = false
